import React from "react";

class IconEdit extends React.Component {
    render() {
        return (
            <svg
                className="icon--edit"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <path
                    d="M16.775,4.4125 L20.5333333,8.11210937 C20.6916667,8.26796875 20.6916667,8.52226562 20.5333333,8.678125 L11.4333333,17.6359375 L7.56666667,18.0583984 C7.05,18.1158203 6.6125,17.6851562 6.67083333,17.1765625 L7.1,13.3703125 L16.2,4.4125 C16.3583333,4.25664062 16.6166667,4.25664062 16.775,4.4125 Z M23.525,3.47324219 L21.4916667,1.47167969 C20.8583333,0.848242187 19.8291667,0.848242187 19.1916667,1.47167969 L17.7166667,2.92363281 C17.5583333,3.07949219 17.5583333,3.33378906 17.7166667,3.48964844 L21.475,7.18925781 C21.6333333,7.34511719 21.8916667,7.34511719 22.05,7.18925781 L23.525,5.73730469 C24.1583333,5.10976562 24.1583333,4.09667969 23.525,3.47324219 Z M16,15.1996094 L16,19.375 L2.66666667,19.375 L2.66666667,6.25 L12.2416667,6.25 C12.375,6.25 12.5,6.19667969 12.5958333,6.10644531 L14.2625,4.46582031 C14.5791667,4.15410156 14.3541667,3.625 13.9083333,3.625 L2,3.625 C0.895833333,3.625 0,4.50683594 0,5.59375 L0,20.03125 C0,21.1181641 0.895833333,22 2,22 L16.6666667,22 C17.7708333,22 18.6666667,21.1181641 18.6666667,20.03125 L18.6666667,13.5589844 C18.6666667,13.1201172 18.1291667,12.9027344 17.8125,13.2103516 L16.1458333,14.8509766 C16.0541667,14.9453125 16,15.0683594 16,15.1996094 Z"
                    fill="currentColor"
                    fillRule="nonzero"
                />
            </svg>
        );
    }
}

export default IconEdit;



// WEBPACK FOOTER //
// ./src/components/icons/IconEdit.jsx